/**
 * 
 * 쿠키를 저장한다.
 * 
 * @param {*} k 
 * @param {*} v 
 * @param {*} options - { httpOnly, secure, sameSite, maxAge }
 */
export const setCookie = (k, v, options = {}) => {
    v = encodeURIComponent(v);
    
    const {
        httpOnly = false,
        secure = false,
        sameSite = 'Lax',
        maxAge = 60 * 60 * 24 * 365 * 100, // 100년 기본값
        path = '/'
    } = options;
    
    let cookieString = `${k}=${v}; max-age=${maxAge}; path=${path}; SameSite=${sameSite}`;
    
    if (secure) {
        cookieString += '; Secure';
    }
    
    // httpOnly는 JavaScript에서 설정할 수 없으므로 서버에서 설정해야 함
    // 여기서는 주석으로만 표시
    if (httpOnly) {
        console.warn('httpOnly 쿠키는 서버에서 설정해야 합니다.');
    }
    
    document.cookie = cookieString;
};

/**
 * 보안 토큰용 쿠키 설정
 * @param {string} key - 쿠키 키
 * @param {string} value - 쿠키 값
 * @param {boolean} isRefreshToken - refresh token 여부 (더 긴 만료시간)
 */
export const setSecureTokenCookie = (key, value, isRefreshToken = false) => {
    const maxAge = isRefreshToken 
        ? 60 * 60 * 24 * 30  // refresh token: 30일
        : 60 * 60 * 2;       // access token: 2시간
    const opt = {
        secure: location.protocol === 'https:',  // HTTPS에서만 secure 설정
        sameSite: 'Strict',
        maxAge: maxAge
    };

    if ( isRefreshToken ) {
        opt['httpOnly'] = true;
    }
    setCookie(key, value, opt);
};

export const deleteCookie = (k) => {
    document.cookie = k + "=; path=/;";
};

/**
 * 쿠키 내보내기.
 * @param {d} k 
 * @param {*} v 
 * @returns 
 */
export const getCookie = (key) => {

    let cookie = {};

    document.cookie.split(';').forEach(function(el) {
        let [k,v] = el.split('=');
        cookie[k.trim()] = !v ? null : decodeURIComponent(v);
    });

    const str = cookie[key] ? decodeURIComponent(cookie[key]) : '';
    
    return str; 

};
